import styled from 'styled-components';
import { mediaMaxWidth } from '@lux/templates';
import { Text } from '@lux/text';
import { Button } from '@lux/buttons';
export const ContentWrapper = styled.div `
    text-align: left;
`;
export const StyledSubscribeText = styled(Text) `
    margin-top: 0;
    margin-bottom: 20px;
`;
export const StyledSwitchAccountText = styled(Text) `
    margin-top: 0;
    margin-bottom: 12px;
`;
export const StyledEmail = styled(Text) `
    white-space: nowrap;
`;
export const StyledSwitchAccountButton = styled(Button) `
    margin-bottom: 42px;
`;
export const SubscribeButtonWrapper = styled.div `
    ${mediaMaxWidth.sm} {
        position: absolute;
        bottom: 40px;
        left: 20px;
        right: 20px;
    }

    margin-top: 16px;
`;
//# sourceMappingURL=styles.js.map